import React, { Component } from 'react';
import Modal from 'react-modal';
import { Button, Row, Col, Collection, CollectionItem, Navbar, NavItem, Icon, Input, Preloader, ProgressBar } from 'react-materialize';
import './ChartEditor.css';
import ChartEditorNavBar from './ChartEditorNavBar';
import ChartEditorMenu from './ChartEditorMenu';
import ChartEditorTitle from './ChartEditorTitle';
import DataPanel from './DataPanel';
import SettingsPanel from './SettingsPanel';
import ColorPanel from './ColorPanel';
import * as _ from 'lodash';
import ResizeDetector from 'react-resize-detector';
const cf = window.cf;
const NO_AXIS_CHARTS = ['Pie','Donut','Tree Map','Nested Pie','Radar','Tree Map 2D','Disk', 'Packed Bubbles', 'Word Cloud'];

export default class ChartEditor extends Component {

    constructor(props){
        super(props);
        this.state = {
            menuActive:'data',
            provider:'Elasticsearch',
            orientation: 'vertical',
            datasource:'ticket_sales',
            group1:{
                name:'venuecity.keyword',
                limit:10,
                sort:{
                    dir:'desc',
                    name:'venuecity.keyword'
                }
            },
            group2:{
                name:'saletime',
                limit:1000,
                func:'MONTH',
                sort:{
                    dir:'asc',
                    name:'saletime'
                }
            },
            group3:{
                name:'venuename.keyword',
                limit:10,
                sort:{
                    dir:'asc',
                    name:'venuename.keyword'
                }
            },
            attributeList:[],
            metricList:[],
            metric1:{ name:'pricepaid', func:'sum' },
            metric2:{ name:'pricepaid', func:'sum' },
            metric3:{ name:'qtysold', func:'sum' },
            chartType:'Bars',
            chartStyle:'Bars',
            legend:{ position:'right', width:150, sort:'none' },
            chart:null,
            sourceChart:null,
            axisLabels:true,
            xAxis: true,
            yAxis: true,
            logScale: false,
            providerList:[],
            marklines:{},
            loading:false,
            firstLoading:false,
            title:props.title,
            placement: '',
            subtitle:props.subtitle,
            customMarkValue:0,
            dataZoom: false,
            colorType: 'sequential',
            colorMetric: { name: 'count' },
            chartHeight: 400,
        }

        this.onResize = this.onResize.bind(this);
    }
    componentDidUpdate(prevProps,prevState){
        var newTitle = {};
        if(prevProps.title != this.props.title){
            newTitle.title = this.props.title;
        }
        if(prevProps.subtitle != this.props.subtitle){
            newTitle.subtitle = this.props.subtitle;
        }
        if(Object.keys(newTitle).length > 0){
            this.setState(newTitle);
        }

    }

    onResize(v1,v2) {
        this.state.chartHeight = v2 - 160;
        this.forceUpdate();
    }

    getColorConf(chart) {
        let conf = {
            type: 'sequential',
            metric: { name: 'count' },
            theme: 'intense'
        }

        // Set the color if any
        if (chart.get('color')) {
            conf.theme = chart.get('color')._theme;
            if(chart.get('color')._metric){
                conf.type = 'metric';
                let cmetric = chart.get('color')._metric;
                if(cmetric._name != 'count'){
                    conf.metric = {
                        name: cmetric._name,
                        func: cmetric._func
                    }
                }
            }
        }

        return conf;
    }

    setSourceChart(){
        let sourceChart = cf.getVisualization(this.props.chartId);
        let chart = cf.getVisualization('ce-visualization') || sourceChart.duplicate();

        if (chart === undefined) {
            chart = sourceChart.duplicate();
        }

        // Reset the grid
        let grid = _.cloneDeep(this.props.grid);
        chart.set('grid', grid)

        // Reset the color configuration
        let colorconf = this.getColorConf(chart)

        chart.on('execute:start',function(){
            this.setState({loading:true});
        }.bind(this))
        chart.on('execute:stop',function(){
            this.setState({loading:false, firstLoading:false});
        }.bind(this))
        chart.element('ce-visualization').execute().then(() => {
            chart.resize();
        });

        let orientation = chart.get('orientation')
        let logScale = _.get(chart.get('yAxis'), 'type', false)

        if (orientation && orientation === 'horizontal') {
            logScale = _.get(chart.get('xAxis'), 'type', false)
        }
        logScale = logScale && logScale === 'log' ? true : false;

        this.setState({
            provider: chart._provider.get('name'),
            datasource: chart.get('source').name,
            attributeList: chart.getFields('attributes'),
            timeList: chart.getFields('attributes','time'),
            metricList: chart.getFields('metrics').filter(m => m.name.indexOf('_id') === -1),
            group1: {
                name: chart.get('config').groups[0].name,
                limit: chart.get('config').groups[0].limit,
                sort: {
                    dir: chart.get('config').groups[0].sort.dir,
                    name: chart.get('config').groups[0].sort.name,
                    metricFunc: chart.get('config').groups[0].sort.metricFunc
                }
            },
            metric1:{
                name: chart.get('config').metrics[0].name,
                func: chart.get('config').metrics[0].func
            },
            chartType: chart._chartType,
            legend: {
                position: chart.get('legend')._position,
                width: chart.get('legend')._width,
                sort: chart.get('legend')._sort
            },
            orientation: chart.get('orientation') || 'vertical',
            placement: chart.get('placement'),
            axisLabels: chart.get('axisLabels'),
            logScale: logScale,
            dataZoom: chart.get('dataZoom') || false,
            xAxis: _.get(chart.get('xAxis'), 'show', true),
            yAxis: _.get(chart.get('yAxis'), 'show', true),
            grid: {
                top: chart.get('grid')._top,
                bottom: chart.get('grid')._bottom,
                left: chart.get('grid')._left,
                right: chart.get('grid')._right
            },
            marklines: this.getMarkLinesStateFromData(
                chart.get('markline') ? chart.get('markline')._data : []
            ),
            sourceChart:sourceChart,
            chart:chart,
            firstLoading: true,
            colorTheme: colorconf.theme,
            colorType: colorconf.type,
            colorMetric: colorconf.metric
        });
    }
    onCloseModal(){
        this.props.close();
        this.state.chart.remove();
    }
    setMenuActive(menu){
        this.setState({menuActive:menu});
    }
    onChangeTitle(value){
        this.setState(value);
    }
    onChangeAttribute(value){
        this.setState(value);
        if('axisLabels' in value){
            this.state.chart.set('axisLabels', value.axisLabels);
        }
        if('xAxis' in value){
            this.state.chart.set('xAxis', { show : value.xAxis });
        }
        if('yAxis' in value){
            this.state.chart.set('yAxis', { show : value.yAxis });
        }
        if('logScale' in value){
            let type = value.logScale ? 'log' : 'value';
            let axis = 'yAxis';
            if (this.hasOrientationSupport() &&
                this.state.placement !== 'stacked' &&
                this.state.orientation === 'horizontal') {
                    axis = 'xAxis'
            }
            this.state.chart.set(axis, { type : type });
        }
        if('legend' in value){
            var legend = cf.Legend().position(value.legend.position).width(value.legend.width).sort(value.legend.sort);
            this.state.chart.set('legend', legend);
        }
        if('orientation' in value){
            let grid = this.state.grid;
            let type = this.state.logScale ? 'log' : 'value';
            let markLines = _.clone(this.state.marklines)
            markLines.hasCustom = false;
            let options = {
                'orientation': value.orientation,
                'xAxis': { show: true },
                'yAxis': { show: true },
                'markline': cf.MarkLine().data(this.getMarkLinesData({ marklines: markLines }))
            };

            if (this.state.dataZoom) {
                grid = this.state.chart.get('__CHART__').grid[0];
                grid.bottom = grid.bottom - 25
                options['grid'] = cf.Grid().top(grid.top).bottom(grid.bottom).left(grid.left).right(grid.right);
            }

            if (value.orientation === 'horizontal') {
                options.xAxis.type = type;
            } else {
                options.yAxis.type = type;
            }

            this.setState({
                dataZoom: false,
                grid: grid,
                xAxis: true,
                yAxis: true,
                marklines: markLines
            })

            this.state.chart.set(options);
        }
        if('grid' in value){
            var grid = cf.Grid().top(value.grid.top).bottom(value.grid.bottom).left(value.grid.left).right(value.grid.right);
            this.state.chart.set('grid', grid);
        }
        if('colorTheme' in value){
            var color = cf.Color().palette(value.colorTheme);
            if(this.state.colorType === 'metric'){
                color.metric(cf.Metric(this.state.colorMetric.name,this.state.colorMetric.func))
            }
            this.state.chart.set('color', color);
        }
        if('marklines' in value){
            var marklines = this.getMarkLinesData(value);
            this.state.chart.set('markline', cf.MarkLine().data(marklines));
        }
        if('dataZoom' in value){
            this.state.chart.set('dataZoom', value.dataZoom);
            var grid = this.state.chart.get('__CHART__').grid[0];
            this.setState({ dataZoom: value.dataZoom , grid: grid })
        }
        if('colorType' in value){
            var color = cf.Color().palette(this.state.colorTheme);
            if(value.colorType === 'metric'){
                color.metric(cf.Metric(this.state.colorMetric.name,this.state.colorMetric.func))
            }
            this.state.chart.set('color', color);
        }
    }
    onChangeConfig(value){
        var newValue = Object.assign(value,{firstLoading:false});
        this.setState(newValue);
        this.renderChart();
    }
    processBarsType(value) {
        value.chartStyle = value.chartType;
        switch (value.chartType) {
            case 'Stacked Bars':
                value.chartType = 'Bars';
                value.placement = 'stacked';
                break
            case 'Multimetric Stacked Bars':
                value.chartType = 'Multimetric Bars';
                value.placement = 'stacked';
                break
            case 'Multimetric Clustered Bars':
                value.chartType = 'Multimetric Bars';
                value.placement = 'clustered';
                break
            case 'Clustered Bars':
                value.chartType = 'Bars';
                value.placement = 'clustered';
                break
            case 'Bars':
                value.placement = '';
                break
        }
        return value;
    }

    getGridMargins(){
        let g = this.state.grid;
        if (g.top === 0 && g.bottom === 0 && g.left === 0 && g.right === 0) {
            return cf.Grid().top(0).bottom(0).left(0).right(0)
        }

        return cf.Grid().top(g.top).bottom(g.bottom).left(g.left).right(g.right)
    }

    onSave(){
        this.state.sourceChart.remove();
        var sourceChart = this.state.chart.duplicate();
        this.state.chart.remove();
        let grid = this.getGridMargins();
        sourceChart.set('grid',_.cloneDeep(grid));
        sourceChart.element(this.props.chartId).execute();

        this.props.close();
        this.props.onSave({
            title: this.state.title,
            subtitle: this.state.subtitle,
            grid: grid
            });
    }

    hasAxisSupport(){
        return (NO_AXIS_CHARTS.indexOf(this.state.chartType) < 0);
    }
    hasGridSupport(){
        return (NO_AXIS_CHARTS.indexOf(this.state.chartType) < 0);
    }
    hasMarkLineSupport(){
        return (NO_AXIS_CHARTS.indexOf(this.state.chartType) < 0);
    }
    includeMinMaxAvg() {
        let charts = [
            'Stacked Bars',
            'Multimetric Stacked Bars',
            'Clustered Bars',
            'Multimetric Clustered Bars',
            'Area Line',
            'Multimetric Area Line',
            'Trend',
            'Multimetric Trend',
            'Floating Bubbles'
        ];
        return charts.indexOf(this.state.chartStyle) == -1;
    }
    hasDataZoomSupport(){
        let charts = ['Trend','Area Line', 'Bars', 'Multimetric Bars','Multimetric Trend', 'Multimetric Area Line'];
        return (charts.indexOf(this.state.chartType) > -1);
    }
    hasOrientationSupport(){
        let charts = ['Bars', 'Multimetric Bars'];
        return (charts.indexOf(this.state.chartType) > -1);
    }
    hasLogSupport(){
        let charts = ['Stacked Bars', 'Multimetric Stacked Bars'];
        return charts.indexOf(this.state.chartStyle) == -1;
    }
    hasLegendSupport() {
        let charts = ['Disk'];
        return charts.indexOf(this.state.chartStyle) == -1;
    }
    hasColorMetricSupport(chartType){
        switch(chartType){
            case 'Area Line':
            case 'Bars and Line':
            case 'Trend':
                return false;
            default:
                return true;
        }
    }
    getMarkLinesData(value){
        var marklines = [];
        if(value.marklines.hasAverage){
            marklines.push({name:'Average',type:'average'});
        }
        if(value.marklines.hasMin){
            marklines.push({name:'Min',type:'min'});
        }
        if(value.marklines.hasMax){
            marklines.push({name:'Max',type:'max'});
        }
        if(value.marklines.hasCustom){
            let axis = 'yAxis'
            if (this.hasOrientationSupport() && this.state.orientation === 'horizontal') axis = 'xAxis';
            marklines.push({name:'Value',[axis]:value.marklines.customValue});
        }
        return marklines;
    }
    getMarkLinesStateFromData(data){
        var marklines = {
            hasAverage: false,
            hasMin: false,
            hasMax: false,
            hasCustom: false,
            customValue: 0
        };
        if(data){
            data.forEach(ml => {
                switch(ml.name){
                    case 'Average':
                        marklines.hasAverage = true;
                        break;
                    case 'Min':
                        marklines.hasMin = true;
                        break;
                    case 'Max':
                        marklines.hasMax = true;
                        break;
                    case 'Value':
                        marklines.hasCustom = true;
                        marklines.customValue = ml.yAxis;
                        break;
                    default:
                        // do nothing
                }
            });
        }

        return marklines;
    }

    getUpdatedConfiguration() {
        var groups = [], colorMetric = this.state.colorMetric, color;
        var group = cf.Attribute(this.state.group1.name).limit(this.state.group1.limit);
        if (this.state.group1.func) {
            group.func(this.state.group1.func);
        }
        var sortMetric = null;
        if (this.state.group1.sort.metricFunc) {
            sortMetric = cf.Metric(this.state.group1.sort.name, this.state.group1.sort.metricFunc);
            group.sort(this.state.group1.sort.dir, sortMetric);
        }
        else {
            group.sort(this.state.group1.sort.dir, this.state.group1.sort.name);
        }
        groups.push(group);
        if (['Trend', 'Area Line'].indexOf(this.state.chartType) > -1) {
            var group2 = cf.Attribute(this.state.group2.name)
                           .limit(this.state.group2.limit);
            if (this.state.group2.func) group2.func(this.state.group2.func);
            if (this.state.group2.sort.metricFunc) {
                group2.sort(this.state.group2.sort.dir, cf.Metric(this.state.group2.sort.name, this.state.group2.sort.metricFunc));
            }
            else {
                group2.sort(this.state.group2.sort.dir, this.state.group2.sort.name);
            }
            groups.push(group2);
        }
        if (['Multimetric Trend', 'Multimetric Area Line'].indexOf(this.state.chartStyle) > -1) {
            var group = cf.Attribute(this.state.group2.name).limit(this.state.group2.limit);
            if (this.state.group2.func) {
                group.func(this.state.group2.func);
            }
            var sortMetric = null;
            if (this.state.group1.sort.metricFunc) {
                sortMetric = cf.Metric(this.state.group1.sort.name, this.state.group1.sort.metricFunc);
                group.sort(this.state.group2.sort.dir, sortMetric);
            }
            else {
                group.sort(this.state.group2.sort.dir, this.state.group1.sort.name);
            }
            groups = [group];
        }
        if (['Nested Pie', 'Stacked Bars', 'Tree Map 2D', 'Clustered Bars', 'Floating Bubbles'].indexOf(this.state.chartStyle) > -1) {
            var group3 = cf.Attribute(this.state.group3.name)
                           .limit(this.state.group3.limit);
            if (this.state.group3.func) group3.func(this.state.group3.func);
            if (this.state.group3.sort.metricFunc) {
                group3.sort(
                    this.state.group3.sort.dir,
                    cf.Metric(this.state.group3.sort.name, this.state.group3.sort.metricFunc)
                );
            }
            else {
                group3.sort(this.state.group3.sort.dir, this.state.group3.sort.name);
            }
            groups.push(group3);
        }
        var metrics = [];
        var metric = cf.Metric(this.state.metric1.name, this.state.metric1.func);
        metrics.push(metric);
        if (['Bars and Line'].indexOf(this.state.chartStyle) > -1) {
            var metric2 = cf.Metric(this.state.metric2.name, this.state.metric2.func);
            metrics.push(metric2);
        }
        else if ([
            'Scatter Plot',
            'Floating Bubbles',
            'Radar',
            'Multimetric Stacked Bars',
            'Multimetric Clustered Bars',
            'Multimetric Trend',
            'Multimetric Area Line'].indexOf(this.state.chartStyle) > -1) {
            var metric2 = cf.Metric(this.state.metric2.name, this.state.metric2.func);
            metrics.push(metric2);
            var metric3 = cf.Metric(this.state.metric3.name, this.state.metric3.func);
            metrics.push(metric3);
        }
        if (sortMetric) {
            var alreadyIncluded = false;
            if (sortMetric._name === 'count') {
                alreadyIncluded = true;
            }
            else {
                metrics.forEach(m => {
                    if ((m._name == sortMetric._name) && (m._func == sortMetric._func)) {
                        alreadyIncluded = true;
                    }
                });
            }
            if (!alreadyIncluded) {
                metrics.push(sortMetric);
            }
        }
        color = cf.Color().palette(this.state.colorTheme);
        if (this.state.colorType === 'metric') {
            var alreadyIncluded = false;
            color.metric(cf.Metric(colorMetric.name, colorMetric.func));
            if (colorMetric.name === 'count') {
                alreadyIncluded = true;
            }
            else {
                metrics.forEach(m => {
                    if ((m._name == colorMetric.name) && (m._func == colorMetric.func)) {
                        alreadyIncluded = true;
                    }
                });
            }
            if (!alreadyIncluded) {
                metrics.push(cf.Metric(colorMetric.name, colorMetric.func));
            }
        }
        return { groups, metrics, color };
    }

    renderChart(rebuild){
        let { groups, metrics, color } = this.getUpdatedConfiguration();
        let opts = ['axisLabels', 'color', 'legend', 'grid', 'placement', 'orientation', 'xAxis', 'markline', 'yAxis', 'dataZoom'];
        let options = _.zipObject(opts, _.map(opts, () => 'unset'))

        options['color'] = color;

        if(this.hasDataZoomSupport()){
            options['dataZoom'] = this.state.dataZoom;
        }
        if(this.hasGridSupport()){
            options['grid'] = cf.Grid()
                                    .top(this.state.grid.top)
                                    .bottom(this.state.grid.bottom)
                                    .left(this.state.grid.left)
                                    .right(this.state.grid.right)
        }

        let type = this.state.logScale ? 'log' : 'value';

        if (this.hasAxisSupport()) {
            options['axisLabels'] = this.state.axisLabels
            options['xAxis'] = { show: this.state.xAxis }
            options['yAxis'] = { show: this.state.yAxis, type: type }
        }

        if (this.hasLegendSupport()) {
            options['legend'] = cf.Legend()
                                    .position(this.state.legend.position)
                                    .width(this.state.legend.width)
                                    .sort(this.state.legend.sort)
        }

        if (['Multimetric Stacked Bars', 'Stacked Bars'].indexOf(this.state.chartStyle) > -1) {
            options['yAxis'] = { show: this.state.yAxis, type: 'value' }
            this.setState({yAxis: this.state.yAxis, logScale: false })
        }

        if (['Multimetric Stacked Bars', 'Stacked Bars', 'Clustered Bars', 'Multimetric Clustered Bars'].indexOf(this.state.chartStyle) > -1) {
            options['placement'] = this.state.placement;
        }

        if (this.hasOrientationSupport()) {
            options['orientation'] = this.state.orientation;

            if (this.state.orientation === 'horizontal') {
                options['xAxis'] = { show: this.state.xAxis, type: type }
                options['yAxis'] = { show: this.state.yAxis }
            }
        }

        if (this.hasMarkLineSupport()) {
            options['markline'] = cf.MarkLine().data(this.getMarkLinesData({ marklines: this.state.marklines }))
        }

        const shouldReverseGroups = ['Multimetric Trend', 'Trend', 'Area Line'].includes(this.state.chartType);
        const groupsParam = shouldReverseGroups ? groups.reverse() : groups;

        this.state.chart
                .groupby(...groupsParam)
                .metrics(...metrics)
                .graph(this.state.chartType)
                .set(options)

        if (rebuild) {
            // Rebuild the visualization object
            this.state.chart.forceRebuild()
            this.setState({firstLoading:true});
        }

       this.state.chart
            .execute()
            .then(() => {
                this.state.chart.resize()
            })
    }

    onChangeFullRefresh(value){
        value = this.processBarsType(value);
        this.setState(value);
        this.renderChart(true)
    }

    render(){
        return <Modal
                    isOpen={this.props.isOpen}
                    contentLabel='Modal'
                    onAfterOpen={this.setSourceChart.bind(this)}
                    style={{content:{
                        padding:'0px'
                    }}}>
                    <ChartEditorNavBar onSave={this.onSave.bind(this)} onClose={this.onCloseModal.bind(this)}/>
                   <Row className="chart-editor-content">
                       <div style={{width:"calc(100% - 300px)", height:"100%"}}>
                        <ChartEditorTitle
                            title={this.state.title}
                            subtitle={this.state.subtitle}
                            onChange={this.onChangeTitle.bind(this)}/>
                        {this.state.firstLoading &&
                            <div style={{width:'auto',height:'auto'}}>
                                <Preloader size='big' color='red' className="spinner"/>
                            </div>
                        }
                        <div id='ce-visualization' style={{width:this.state.chartWidth + 'px',height: this.state.chartHeight+'px',display:(this.state.firstLoading ? 'none' : 'block')}}>
                        </div>
                       </div>
                       <div style={{width:"215px", height:"100%", position:"absolute", top: 0, right: "75px"}}>
                        {this.state.menuActive == 'data' &&
                            <DataPanel
                                provider={this.state.provider}
                                datasource={this.state.datasource}
                                chartType={this.state.chartType}
                                chartStyle={this.state.chartStyle}
                                placement={this.state.placement}
                                group1={this.state.group1}
                                group2={this.state.group2}
                                group3={this.state.group3}
                                attributeList={this.state.attributeList}
                                timeList={this.state.timeList}
                                metricList={this.state.metricList}
                                metric1={this.state.metric1}
                                metric2={this.state.metric2}
                                metric3={this.state.metric3}
                                providerList={this.state.provideList}
                                onChangeAttribute={this.onChangeAttribute.bind(this)}
                                onChangeConfig={this.onChangeConfig.bind(this)}
                                onChangeFullRefresh={this.onChangeFullRefresh.bind(this)}/>
                        }
                         {this.state.menuActive == 'settings' &&
                            <SettingsPanel
                                chartType={this.state.chartType}
                                legend={this.state.legend}
                                orientation={this.state.orientation}
                                axisLabels={this.state.axisLabels}
                                xAxis={this.state.xAxis}
                                yAxis={this.state.yAxis}
                                logScale={this.state.logScale}
                                grid={this.state.grid}
                                chartStyle={this.state.chartStyle}
                                marklines={this.state.marklines}
                                customMarkValue={this.state.customMarkValue}
                                hasDataZoomSupport={this.hasDataZoomSupport.bind(this)}
                                hasLogSupport={this.hasLogSupport.bind(this)}
                                hasLegendSupport={this.hasLegendSupport.bind(this)}
                                hasAxisSupport={this.hasAxisSupport.bind(this)}
                                hasMarkLineSupport={this.hasMarkLineSupport.bind(this)}
                                includeMinMaxAvg={this.includeMinMaxAvg.bind(this)}
                                hasOrientationSupport={this.hasOrientationSupport.bind(this)}
                                hasGridSupport={this.hasGridSupport.bind(this)}
                                dataZoom={this.state.dataZoom}
                                onChangeAttribute={this.onChangeAttribute.bind(this)}/>
                        }
                        {this.state.menuActive == 'colors' &&
                            <ColorPanel
                                chartType={this.state.chartType}
                                chartStyle={this.state.chartStyle}
                                theme={this.state.colorTheme}
                                colorType={this.state.colorType}
                                colorMetric={this.state.colorMetric}
                                metricList={this.state.metricList}
                                onChangeConfig={this.onChangeConfig.bind(this)}
                                onChangeAttribute={this.onChangeAttribute.bind(this)}/>
                        }
                       </div>
                       <div className="chart-editor-menu-ct">
                        <ChartEditorMenu
                            menuActive={this.state.menuActive}
                            setMenuActive={this.setMenuActive.bind(this)}/>
                       </div>
                   </Row>
                   <ResizeDetector handleWidth handleHeight onResize={this.onResize} />
                </Modal>
    }
}



// WEBPACK FOOTER //
// ./src/components/chart-editor/ChartEditor.jsx